<template>
  <div class="transfer-record">
    <div class="content">
      <a-breadcrumb class="breadcrumb">
        <a-breadcrumb-item>
          <router-link to="/">
            <a-icon type="home" />
            <span>首页</span>
          </router-link>
        </a-breadcrumb-item>
        <a-breadcrumb-item>
          <router-link :to="'/user-list/' + $route.params.platform">
            {{ bankName }}用户列表
          </router-link>
        </a-breadcrumb-item>
        <a-breadcrumb-item>转账记录</a-breadcrumb-item>
      </a-breadcrumb>

      <!-- <div class="user-info">
        <h3>用户信息</h3>
        <a-descriptions :column="6">
          <a-descriptions-item label="用户名">{{ userInfo.username }}</a-descriptions-item>
          <a-descriptions-item label="姓名">{{ userInfo.name }}</a-descriptions-item>
          <a-descriptions-item label="手机号">{{ userInfo.mobile }}</a-descriptions-item>
          <a-descriptions-item label="身份证">{{ userInfo.idcard }}</a-descriptions-item>
          <a-descriptions-item label="银行卡号">{{ userInfo.card?.card_num }}</a-descriptions-item>
          <a-descriptions-item label="余额">{{ userInfo.money }}</a-descriptions-item>
        </a-descriptions>
      </div> -->

      <!-- 基础配置 -->
      <a-card title="" class="config-card" style="padding: 0  !important;">
        <!-- 工具栏标题和展开/收缩按钮 -->
        <div class="toolbar-header">
          <h3 class="toolbar-title">基础配置</h3>
          <a-button type="link" @click="toggleConfigExpanded" class="expand-toggle-btn"
            :title="configExpanded ? '收缩配置面板' : '展开配置面板'">
            <a-icon :type="configExpanded ? 'up' : 'down'" />
            {{ configExpanded ? '收缩' : '展开' }}
          </a-button>
        </div>

        <!-- 可展开/收缩的表单内容 -->
        <a-collapse-transition>
          <div v-show="configExpanded" class="config-content">
            <a-form :form="form" layout="inline">
              <a-form-item label="时间范围" >
                <a-range-picker  v-decorator="['dateRange', { rules: [{ required: true, message: '请选择时间范围' }] }]"
                  format="YYYY-MM-DD" :ranges="dateRanges" style="width: 200px" @change="handleDateRangeChange" />
              </a-form-item>
              <a-form-item label="开始余额">
                <a-input-number v-decorator="['startBalance', { rules: [{ required: true, message: '请输入开始余额' }] }]"
                  :min="0" :step="100" style="width: 80px" />
              </a-form-item>
              <a-form-item label="生成条数">
                <a-input-number v-decorator="['generateCount', { rules: [{ required: true, message: '请输入生成条数' }] }]"
                  :min="1" style="width: 80px" />
              </a-form-item>
              <a-form-item>
                <a-checkbox v-decorator="['clearExisting', { valuePropName: 'checked', initialValue: true }]">
                  清除原有内容
                </a-checkbox>
              </a-form-item>
              <!-- 工具栏区域 -->
              <a-form-item>
                <!-- 紧凑的工具栏布局 -->
                <div class="compact-toolbar">
                  <!-- 主要操作组 - 始终显示 -->
                  <div class="toolbar-group primary-actions">
                    <a-button-group size="small">
                      <a-button type="primary" @click="handleGenerate" :loading="loading">
                        <a-icon type="thunderbolt" />生成
                      </a-button>
                      <a-button type="primary" @click="handleCalculateBalance">
                        <a-icon type="calculator" />计算余额
                      </a-button>
                    </a-button-group>

                    <a-checkbox v-model="calculateInterest" class="interest-checkbox">
                      计算利息
                    </a-checkbox>
                  </div>

                  <div class="toolbar-group secondary-actions">
                    <a-button-group size="small">
                      <a-button @click="handleGotoBatchConfig">
                        <a-icon type="setting" />批量配置
                      </a-button>
                      <a-button @click="handlePrintTemplateManage">
                        <a-icon type="profile" />打印模板
                      </a-button>
                      <a-button @click="handleShowReport">
                        <a-icon type="bar-chart" />数据报表
                      </a-button>
                    </a-button-group>
                  </div>
                </div>
              </a-form-item>
            </a-form>
          </div>
        </a-collapse-transition>
      </a-card>

      <!-- 打印模板管理弹窗 -->
      <print-template-manager :visible.sync="printTemplateModalVisible" :platform="$route.params.platform"
        :user-id="$route.params.userId" @close="handlePrintTemplateModalClose" />

      <!-- 添加打印模板选择弹窗 -->
      <a-modal title="选择打印模板" :visible="printTemplateSelectVisible" @cancel="printTemplateSelectVisible = false"
        :footer="null" width="500px">
        <div class="print-template-select">
          <!-- 模板选择区域 -->
          <div class="template-section">
            <h4 style="margin-bottom: 12px; color: #333; font-weight: 500;">
              <a-icon type="profile" style="margin-right: 8px;" />
              请选择要使用的打印模板：
            </h4>
            <a-radio-group v-model="selectedTemplateId" style="width: 100%">
              <a-radio v-for="template in availableTemplates" :key="template.id" :value="template.id"
                style="display: block; margin-bottom: 10px; padding: 8px; border-radius: 4px;"
                :class="{ 'selected-template': selectedTemplateId === template.id }">
                {{ template.name }}
              </a-radio>
            </a-radio-group>
          </div>

          <!-- 排序选择区域 -->
          <div class="sort-section" style="margin-top: 24px; padding-top: 16px; border-top: 1px solid #f0f0f0;">
            <h4 style="margin-bottom: 12px; color: #333; font-weight: 500;">
              <a-icon type="sort-ascending" style="margin-right: 8px;" />
              排序方式：
              <span style="font-size: 12px; color: #999; font-weight: normal; margin-left: 8px;">
                (您的选择将被记住)
              </span>
            </h4>
            <a-radio-group v-model="sortType" style="width: 100%">
              <a-radio value="asc" style="display: block; margin-bottom: 8px; padding: 6px;">
                <a-icon type="sort-ascending" style="margin-right: 6px; color: #52c41a;" />
                升序 (时间从早到晚)
              </a-radio>
              <a-radio value="desc" style="display: block; margin-bottom: 8px; padding: 6px;">
                <a-icon type="sort-descending" style="margin-right: 6px; color: #1890ff;" />
                降序 (时间从晚到早)
              </a-radio>
            </a-radio-group>
          </div>

          <!-- 操作按钮区域 -->
          <div style="margin-top: 24px; text-align: right; padding-top: 16px; border-top: 1px solid #f0f0f0;">
            <a-button @click="printTemplateSelectVisible = false">取消</a-button>
            <a-button type="primary" @click="handleConfirmPrint" style="margin-left: 8px">
              <a-icon type="printer" />
              确认打印
            </a-button>
          </div>
        </div>
      </a-modal>

      <!-- 添加数据报表弹窗 -->
      <a-modal title="交易数据统计" :dialog-style="{ top: '20px' }" :visible="reportModalVisible" @cancel="handleReportModalClose" width="80vw"
        :footer="null">
        <transaction-chart v-if="reportModalVisible" :platform="$route.params.platform"
          :user-id="$route.params.userId" />
      </a-modal>


      <!-- 动态加载对应银行的转账记录表格组件 -->
      <TransferRecordTable :userId="$route.params.userId" :platform="$route.params.platform"
        ref="transferRecordTable" />
    </div>
  </div>
</template>

<script>
import { platformMap } from '@/config/tableColumns'
import request from '@/utils/request'
import { API } from '@/config/api'
// import JsTransferRecordTable from '@/components/bank-transfer-record-tables/JsTransferRecordTable.vue'
// import ZgTransferRecordTable from '@/components/bank-transfer-record-tables/ZgTransferRecordTable.vue'
// import YzTransferRecordTable from '@/components/bank-transfer-record-tables/YzTransferRecordTable.vue'
// import NyTransferRecordTable from '@/components/bank-transfer-record-tables/NyTransferRecordTable.vue'
// import WxTransferRecordTable from '@/components/bank-transfer-record-tables/WxTransferRecordTable.vue'
import TransferRecordTable from '@/components/bank-transfer-record-tables/TransferRecordTable.vue'
import PrintTemplateManager from '@/components/bank-print/PrintTemplateManager.vue'
import TransactionChart from '@/components/bank-chart/TransactionChart.vue'
import moment from 'moment'
import printTemplateConfig from '@/config/printTemplate'

export default {
  name: 'TransferRecord',
  components: {
    //   JsTransferRecordTable,
    //   ZgTransferRecordTable,
    //   YzTransferRecordTable,
    //   NyTransferRecordTable,
    //   WxTransferRecordTable,
    TransferRecordTable,
    PrintTemplateManager,
    TransactionChart
  },
  data() {
    return {
      userInfo: {},
      loading: false,
      calculateInterest: true,
      configExpanded: true, // 配置面板展开状态
      toolbarExpanded: true, // 工具栏展开状态
      form: this.$form.createForm(this, {
        onValuesChange: (props, values) => {
          // 当表单值变化时保存到本地存储
          this.saveFormToStorage(values);
        }
      }),
      printTemplateModalVisible: false,
      reportModalVisible: false,
      printTemplateSelectVisible: false,
      selectedTemplateId: null,
      availableTemplates: [],
      sortType: 'asc' // 默认升序，将在created中从localStorage恢复
    }
  },
  computed: {
    bankName() {
      return platformMap[this.$route.params.platform] || '未知平台'
    },
    transferRecordComponent() {
      // const componentMap = {
      //   js: 'JsTransferRecordTable',
      //   zg: 'ZgTransferRecordTable',
      //   yz: 'YzTransferRecordTable',
      //   ny: 'NyTransferRecordTable',
      //   wx: 'WxTransferRecordTable'
      // }
      // return componentMap[this.$route.params.platform] || 'JsTransferRecordTable'
      return 'TransferRecordTable'
    },
    dateRanges() {
      return {
        '今天': [moment().startOf('day'), moment().endOf('day')],
        '本周': [moment().startOf('week'), moment().endOf('week')],
        '本月': [moment().startOf('month'), moment().endOf('month')],
        '最近7天': [moment().subtract(7, 'days'), moment()],
        '最近30天': [moment().subtract(30, 'days'), moment()],
        '最近三个月': [moment().subtract(3, 'month'), moment()],
        '最近半年': [moment().subtract(6, 'month'), moment()],
        '最近一年': [moment().subtract(1, 'year'), moment()]
      }
    }
  },
  methods: {
    // 切换配置面板展开/收缩状态
    toggleConfigExpanded() {
      this.configExpanded = !this.configExpanded;
      // 保存状态到本地存储
      const storageKey = `config_expanded_${this.$route.params.platform}_${this.$route.params.userId}`;
      localStorage.setItem(storageKey, JSON.stringify(this.configExpanded));
    },
    // 切换工具栏展开/收缩状态
    toggleToolbarExpanded() {
      this.toolbarExpanded = !this.toolbarExpanded;
      // 保存状态到本地存储
      const storageKey = `toolbar_expanded_${this.$route.params.platform}_${this.$route.params.userId}`;
      localStorage.setItem(storageKey, JSON.stringify(this.toolbarExpanded));
    },
    // 恢复配置面板展开状态
    restoreConfigExpandedState() {
      try {
        const storageKey = `config_expanded_${this.$route.params.platform}_${this.$route.params.userId}`;
        const savedState = localStorage.getItem(storageKey);
        if (savedState !== null) {
          this.configExpanded = JSON.parse(savedState);
        }
      } catch (error) {
        console.warn('恢复配置面板状态失败:', error);
        this.configExpanded = true; // 默认展开
      }
    },
    // 恢复工具栏展开状态
    restoreToolbarExpandedState() {
      try {
        const storageKey = `toolbar_expanded_${this.$route.params.platform}_${this.$route.params.userId}`;
        const savedState = localStorage.getItem(storageKey);
        if (savedState !== null) {
          this.toolbarExpanded = JSON.parse(savedState);
        }
      } catch (error) {
        console.warn('恢复工具栏状态失败:', error);
        this.toolbarExpanded = true; // 默认展开
      }
    },
    handleDateRangeChange(dates) {
      // 当时间范围改变时，自动保存到本地存储
      if (dates && dates.length === 2) {
        const [startDate, endDate] = dates;
        // 将范围选择器的值转换为单独的开始时间和结束时间
        this.form.setFieldsValue({
          startTime: startDate,
          endTime: endDate
        });
      } else {
        // 清空时间选择
        this.form.setFieldsValue({
          startTime: undefined,
          endTime: undefined
        });
      }
      // 保存表单数据
      this.saveFormToStorage({ dateRange: dates });
    },
    async fetchUserInfo() {
      try {
        const params = {
          platform: this.$route.params.platform,
          id: this.$route.params.userId
        }
        const res = await request.post(API.USER_INFO, params)
        if (res.data) {
          this.userInfo = res.data
        }
      } catch (error) {
        this.$message.error('获取用户信息失败：' + error.message)
      }
    },
    handleGenerate() {
      this.form.validateFields(async (err, values) => {
        if (!err) {
          // if (!this.userInfo.card?.id) {
          //   this.$message.error('未获取到用户卡片信息')
          //   return
          // }

          // 处理时间范围数据
          let startTime, endTime;
          if (values.dateRange && values.dateRange.length === 2) {
            [startTime, endTime] = values.dateRange;
          } else {
            this.$message.error('请选择时间范围');
            return;
          }

          // 根据是否清除原有内容显示不同的确认提示
          const confirmMessage = values.clearExisting ?
            '生成会删除之前生成的数据，是否继续？' :
            '生成的数据将追加到现有记录，是否继续？';

          this.$confirm({
            title: '确认生成',
            content: confirmMessage,
            okText: '确认',
            cancelText: '取消',
            onOk: async () => {
              this.loading = true
              try {
                const config = {
                  platform: this.$route.params.platform,
                  user_id: this.$route.params.userId,
                  card_id: this.userInfo.card.id,
                  start_time: startTime,
                  end_time: endTime,
                  start_balance: values.startBalance,
                  generate_count: values.generateCount,
                  clear_existing: values.clearExisting // 添加是否清除原有内容的参数
                }
                const res = await request.post(API.BATCH_GENERATE, config)
                if (res.code === 1) {
                  this.$message.success('生成成功')
                  // 刷新表格数据
                  this.$refs.transferRecordTable?.fetchRecordData()
                  // 更新用户余额
                  this.fetchUserInfo()
                } else {
                  this.$message.error(res.msg || '生成失败')
                }
              } catch (error) {
                this.$message.error(error.message || '生成失败')
              } finally {
                this.loading = false
              }
            }
          })
        }
      })
    },
    handleGotoBatchConfig() {
      this.$router.push({
        name: 'BatchGenerateConfig',
        params: {
          platform: this.$route.params.platform,
          userId: this.$route.params.userId
        }
      })
    },
    async handleCalculateBalance() {
      this.form.validateFields(['startBalance'], async (err, values) => {
        if (!err) {
          try {
            const res = await request.post(API.CALCULATE_BALANCE, {
              platform: this.$route.params.platform,
              user_id: this.$route.params.userId,
              start_balance: values.startBalance,
              calculate_interest: this.calculateInterest
            })
            console.log('[handleCalculateBalance] res:', res);
            if (res.code === 1) {
              this.$message.success('余额计算成功')
              // 刷新表格数据
              await this.$refs.transferRecordTable?.fetchRecordData()

              this.hasNegativeBalanceRecord();

              if (this.$route.params.platform != 'js') {
                // 更新表单中的开始余额值
                this.form.setFieldsValue({
                  startBalance: res.data.start_balance
                });
              }


              // 刷新用户信息
              this.fetchUserInfo()
            } else {
              this.$message.error(res.msg || '余额计算失败')
            }
          } catch (error) {
            this.$message.error(error.message || '余额计算失败')
          }
        } else {
          this.$message.error('请输入开始余额')
        }
      })
    },
    handlePrintTemplateManage() {
      // 在弹出打印模板选择对话框前，先验证表单
      this.form.validateFields(['dateRange'], (err, values) => {
        if (err || !values.dateRange || values.dateRange.length !== 2) {
          this.$message.error('请先选择时间范围，再进行打印操作');
          return;
        }

        // 验证通过后再弹出打印模板选择对话框
        this.printTemplateSelectVisible = true;
      });
    },
    handlePrintTemplateModalClose() {
      this.printTemplateModalVisible = false
    },
    handleShowReport() {
      // 直接打开数据报表弹窗，时间筛选在报表内部处理
      this.reportModalVisible = true
    },
    handleReportModalClose() {
      this.reportModalVisible = false
    },
    // 保存表单数据到本地存储
    saveFormToStorage(changedValues) {
      try {
        const storageKey = `generate_form_${this.$route.params.platform}_${this.$route.params.userId}`;
        const currentValues = this.form.getFieldsValue();
        const values = {
          ...currentValues,
          ...changedValues
        };

        // 处理时间范围数据
        if (changedValues.dateRange) {
          values.dateRange = changedValues.dateRange ?
            changedValues.dateRange.map(date => date ? date.format('YYYY-MM-DD') : null) :
            null;
        } else if (currentValues.dateRange) {
          values.dateRange = currentValues.dateRange.map(date => date ? date.format('YYYY-MM-DD') : null);
        }

        localStorage.setItem(storageKey, JSON.stringify(values));
      } catch (error) {
        console.warn('保存表单数据失败:', error);
      }
    },
    // 从本地存储恢复表单数据
    restoreFormFromStorage() {
      try {
        const storageKey = `generate_form_${this.$route.params.platform}_${this.$route.params.userId}`;
        const savedData = localStorage.getItem(storageKey);
        if (savedData) {
          const values = JSON.parse(savedData);

          // 转换时间范围字符串为moment对象数组
          if (values.dateRange && Array.isArray(values.dateRange) && values.dateRange.length === 2) {
            values.dateRange = values.dateRange.map(dateStr =>
              dateStr ? moment(dateStr) : null
            ).filter(date => date && date.isValid());

            // 如果时间范围有效，设置表单值
            if (values.dateRange.length === 2) {
              this.form.setFieldsValue(values);
            }
          } else {
            // 如果没有有效的时间范围，只恢复其他字段
            delete values.dateRange;
            this.form.setFieldsValue(values);
          }
        }
      } catch (error) {
        console.warn('恢复表单数据失败:', error);
      }
    },
    // 保存打印排序偏好到本地存储（按平台保存）
    savePrintSortPreference() {
      try {
        const storageKey = `print_sort_preference_${this.$route.params.platform}`;
        const preference = {
          sortType: this.sortType,
          lastUpdated: Date.now()
        };
        localStorage.setItem(storageKey, JSON.stringify(preference));
        console.log('排序偏好已保存:', preference);
      } catch (error) {
        console.warn('保存排序偏好失败:', error);
      }
    },
    // 从本地存储恢复打印排序偏好（按平台恢复）
    restorePrintSortPreference() {
      try {
        const storageKey = `print_sort_preference_${this.$route.params.platform}`;
        const savedData = localStorage.getItem(storageKey);
        if (savedData) {
          const preference = JSON.parse(savedData);
          if (preference.sortType && ['asc', 'desc'].includes(preference.sortType)) {
            this.sortType = preference.sortType;
            console.log('排序偏好已恢复:', preference);
          }
        }
      } catch (error) {
        console.warn('恢复排序偏好失败:', error);
        // 如果恢复失败，使用默认值
        this.sortType = 'asc';
      }
    },
    async handleConfirmPrint() {
      try {
        // 验证表单中必须填写时间范围
        this.form.validateFields(['dateRange'], async (err, values) => {
          if (err || !values.dateRange || values.dateRange.length !== 2) {
            this.$message.error('请先选择时间范围');
            return;
          }

          try {
            // 使用表单中的时间范围，不再从后台获取
            const [startTime, endTime] = values.dateRange;
            const dateRange = {
              startTime: Math.floor(startTime.valueOf() / 1000),
              endTime: Math.floor(endTime.valueOf() / 1000)
            };


            // 获取当前银行的默认模板ID
            const bankCode = this.$route.params.platform;
            const defaultTemplateId = this.selectedTemplateId || printTemplateConfig.getDefaultTemplateId(bankCode);
            if (!defaultTemplateId) {
              this.$message.error(`未找到${this.bankName}的默认打印模板`);
              return;
            }

            // 获取模板路径
            const templatePath = printTemplateConfig.getTemplatePath(defaultTemplateId);
            if (!templatePath) {
              this.$message.error(`模板路径不存在: ${defaultTemplateId}`);
              return;
            }

            // 关闭模板选择对话框
            this.printTemplateSelectVisible = false;

            console.log('准备打印，交易时间范围:', dateRange);
            console.log('使用模板:', defaultTemplateId, templatePath);
            this.$message.info(`准备使用${this.bankName}模板打印...`);

            try {
              // 构建URL参数
              const urlParams = new URLSearchParams();
              urlParams.append('platform', bankCode);
              urlParams.append('userid', this.$route.params.userId);
              urlParams.append('templatename', defaultTemplateId);
              urlParams.append('starttime', dateRange.startTime);
              urlParams.append('endtime', dateRange.endTime);
              urlParams.append('sort', this.sortType);

              // 构建URL协议链接
              const url = `bankflow://?${urlParams.toString()}`;
              console.log('执行打印URL:', url);

              // 打开URL协议
              window.location.href = url;

              this.$message.success('打印请求已发送');
            } catch (error) {
              console.error('打印失败:', error);
              this.$message.error('打印失败: ' + (error.message || '未知错误'));
            }
          } catch (error) {
            console.error('打印失败:', error);
            this.$message.error('打印失败: ' + (error.message || '未知错误'));
          }
        });
      } catch (error) {
        console.error('打印失败:', error);
        this.$message.error('打印失败: ' + (error.message || '未知错误'));
      }
    },
    async getAvailableTemplates() {
      try {
        // 使用本地配置获取可用模板
        const bankCode = this.$route.params.platform;
        const bankTemplates = printTemplateConfig.getTemplatesByBank(bankCode);

        if (bankTemplates && bankTemplates.templates) {
          this.availableTemplates = bankTemplates.templates;
          this.selectedTemplateId = bankTemplates.defaultTemplate;
        } else {
          this.$message.warning(`未找到${this.bankName}的打印模板配置`);
        }
      } catch (error) {
        console.error('获取可用模板出错:', error);
        this.$message.error('获取可用模板失败: ' + error.message);
      }
    },
    getTemplateTypeName(typeCode) {
      return printTemplateConfig.getTemplateTypeName(typeCode);
    },
    // 计算是否有余额为负的记录
    hasNegativeBalanceRecord() {
      const negativeRecord = this.$refs.transferRecordTable?.negativeBalanceRecord;
      console.log('[hasNegativeBalanceRecord] negativeRecord:', negativeRecord);
      if (negativeRecord) {
        // 绝对值
        let balance = Math.abs(Number(negativeRecord.balance));
        if (balance > 0) {
          this.form.setFieldsValue({
            startBalance: this.form.getFieldValue('startBalance') + balance
          });
        }
      }
    }
  },
  created() {
    this.fetchUserInfo()
    // 恢复配置面板展开状态
    this.restoreConfigExpandedState();
    // 恢复工具栏展开状态
    this.restoreToolbarExpandedState();
    // 恢复打印排序偏好
    this.restorePrintSortPreference();
    // 在组件创建后恢复表单数据
    this.$nextTick(() => {
      this.restoreFormFromStorage();
    });
    this.getAvailableTemplates();
  },
  watch: {
    // 监听排序类型变化，自动保存用户偏好
    sortType(newVal, oldVal) {
      if (newVal !== oldVal && newVal) {
        this.savePrintSortPreference();
      }
    }
  }
}
</script>

<style scoped>
.transfer-record {
}

.content {
  background: #fff;
  padding: 10px;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

/* 打印模板选择弹窗样式 */
.print-template-select {
  padding: 8px 0;
}

.template-section,
.sort-section {
  margin-bottom: 16px;
}

.template-section h4,
.sort-section h4 {
  display: flex;
  align-items: center;
  margin-bottom: 12px;
  font-size: 14px;
}

/* 选中的模板样式 */
.selected-template {
  background-color: #f6ffed !important;
  border: 1px solid #b7eb8f !important;
}

/* 排序选项悬停效果 */
.ant-radio-wrapper:hover {
  background-color: #fafafa;
  border-radius: 4px;
}

/* 排序图标颜色 */
.sort-section .ant-radio-wrapper .anticon-sort-ascending {
  color: #52c41a;
}

.sort-section .ant-radio-wrapper .anticon-sort-descending {
  color: #1890ff;
}

.breadcrumb {
  margin-bottom: 16px;
  text-align: left;
}

.user-info {
  margin: 20px 0;
}

.print-template-modal .template-header {
  margin-bottom: 16px;
}

/* 工具栏样式 */
.toolbar-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #f0f0f0;
}

.toolbar-title {
  margin: 0;
  font-size: 16px;
  font-weight: 500;
  color: #262626;
}

.expand-toggle-btn {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 4px 8px;
  color: #1890ff;
  transition: all 0.3s ease;
}

.expand-toggle-btn:hover {
  color: #40a9ff;
  background-color: #f6ffed;
}

.config-content {
  transition: all 0.3s ease;
}

/* 过渡动画 */
.a-collapse-transition {
  transition: all 0.3s ease;
}

/* 工具栏样式优化 */
.toolbar-container {
  margin-bottom: 0 !important;
}

.toolbar-actions-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
  padding: 8px 0;
  border-bottom: 1px solid #f0f0f0;
}

.toolbar-actions-title {
  font-size: 14px;
  font-weight: 500;
  color: #595959;
}

.toolbar-toggle-btn {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 2px 6px;
  color: #1890ff;
  transition: all 0.3s ease;
  font-size: 12px;
}

.toolbar-toggle-btn:hover {
  color: #40a9ff;
  background-color: #f6ffed;
}

.compact-toolbar {
  display: flex;
  gap: 12px;
}

.toolbar-group {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}

.primary-actions {
  justify-content: flex-start;
}



.interest-checkbox {
  margin: 0 !important;
  font-size: 13px;
  color: #666;
}

/* 按钮组样式优化 */
.ant-btn-group-small>.ant-btn {
  padding: 4px 8px;
  font-size: 13px;
  height: 28px;
  border-radius: 4px;
}

.ant-btn-group-small>.ant-btn:first-child {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.ant-btn-group-small>.ant-btn:last-child {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.ant-btn-group-small>.ant-btn:not(:first-child):not(:last-child) {
  border-radius: 0;
}

/* 主要按钮样式 */
.primary-actions .ant-btn-primary {
  background: linear-gradient(135deg, #1890ff 0%, #096dd9 100%);
  border-color: #1890ff;
  box-shadow: 0 2px 4px rgba(24, 144, 255, 0.2);
  transition: all 0.3s ease;
}

.primary-actions .ant-btn-primary:hover {
  background: linear-gradient(135deg, #40a9ff 0%, #1890ff 100%);
  border-color: #40a9ff;
  box-shadow: 0 4px 8px rgba(24, 144, 255, 0.3);
  transform: translateY(-1px);
}

/* 次要按钮样式 */
.secondary-actions .ant-btn {
  background: #fafafa;
  border-color: #d9d9d9;
  color: #595959;
  transition: all 0.3s ease;
}

.secondary-actions .ant-btn:hover {
  background: #e6f7ff;
  border-color: #91d5ff;
  color: #1890ff;
  transform: translateY(-1px);
}

/* 图标样式优化 */
.ant-btn .anticon {
  margin-right: 4px;
  font-size: 12px;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .toolbar-group {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }

  .compact-toolbar {
    gap: 8px;
  }

  .ant-btn-group-small {
    display: flex;
    flex-direction: column;
    width: 100%;
  }

  .ant-btn-group-small>.ant-btn {
    border-radius: 4px !important;
    margin-bottom: 4px;
  }
}
</style>

<style>
/* 覆盖 ant-design 卡片内容区域的内边距 */
.ant-card-body {
  padding: 0 !important;
}

.ant-form label{
  font-size: 12px !important;
}

.ant-input{
  padding: 0 !important;
}


</style>